// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__W-QNQ","form":"styles_form__1Pwe1"};